import type { FC, ReactNode } from 'react';
import styles from '../styles/blue-card.module.scss';

const BlueCard: FC<{
    className?: string;
    children: ReactNode;
}> = ({ className = '', children }) => {
    return <div className={`${styles.blueCard} ${className}`}>{children}</div>;
};

export default BlueCard;
